import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
var AnimatedNumber = function (_a) {
    var _b = _a.duration, duration = _b === void 0 ? 2000 : _b, formatter = _a.formatter, target = _a.target;
    var _c = useState(0), displayValue = _c[0], setDisplayValue = _c[1];
    var rafRef = useRef(null);
    var startValueRef = useRef(target);
    var startTimeRef = useRef(null);
    useEffect(function () {
        // Cancel any ongoing animation
        if (rafRef.current)
            cancelAnimationFrame(rafRef.current);
        startValueRef.current = displayValue;
        startTimeRef.current = null;
        var animate = function (timestamp) {
            if (!startTimeRef.current) {
                startTimeRef.current = timestamp;
            }
            var elapsed = timestamp - startTimeRef.current;
            var progress = Math.min(elapsed / duration, 1);
            var nextValue = startValueRef.current + (target - startValueRef.current) * progress;
            setDisplayValue(nextValue);
            if (progress < 1) {
                rafRef.current = requestAnimationFrame(animate);
            }
            else {
                setDisplayValue(target); // Snap to final value
                rafRef.current = null;
            }
        };
        rafRef.current = requestAnimationFrame(animate);
        return function () {
            if (rafRef.current)
                cancelAnimationFrame(rafRef.current);
        };
    }, [target, duration]);
    var formatted = formatter ? formatter(Math.round(displayValue)) : Math.round(displayValue);
    return _jsx("span", { children: formatted });
};
export default AnimatedNumber;
